
import { useFAQ } from "../../hooks/collections/useFAQ";
import { IFAQ } from "../../@core/interfaces/IFAQ";

export const FAQPage = () => {
  const { faqs, fetched: loading } = useFAQ({ loadData: true });
  const question = ({ question, answer }) => {
    return (
      <div className={"flex flex-col gap-3 p-5"}>
        <div className={"font-semibold text-lg"}>{question}</div>
        <div className={"text-sm text-neutral-600 dark:text-gray-300 text-md"}>
          {answer}
        </div>
      </div>
    )
  }

  return (
    <>
    <div className={"flex flex-col gap-3 justify-center items-center max-w-7xl mx-auto py-20"}>
      <div className={"font-black text-5xl text-center"}>Frequently asked questions</div>
      <div className={"text-center px-5 md:max-w-[600px] mx-auto"}>
        Have a different question and can’t find the answer you’re looking for? Reach out to our support team by <span className={"text-red-500 hover:cursor-pointer hover:underline"}>sending us an email</span> and we’ll get back to you as soon as we can.
      </div>

      <div className={"grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10 md:p-10"}>
        {!loading ? (
          <div className="col-span-3 text-center">Loading FAQs...</div>
        ) : faqs && faqs.length > 0 ? (
          faqs.map((faq: IFAQ) => (
            <div key={faq.id}>
              {question({
                question: faq.question,
                answer: faq.answer
              })}
            </div>
          ))
        ) : (
          <div className="col-span-3 text-center">No FAQs available at the moment.</div>
        )}
      </div>
    </div>
    </>
  )
}
